///<reference path="../../App/plugins/DefinitelyTyped/google.maps.d.ts"/>
import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { MySharedService } from '../App/shared.service'
declare function AddMapScript(): void;
@Component({
    templateUrl: './AppViews/Attendance/Attendance.html'
})

export class AttendanceComponent implements OnInit {
    public attendanceDetail: any = {};
    public userDetail: any;
    public showDetail: boolean;
    public geoError: string = "";
    public timer: any;
    public utcTime: any;
    constant: Constants;
    public myDate: any;
    public attendanceModel: any = {};
    public geoLocationModel: any = {};
    public showOutBtn: boolean;
    public showOutTimelbl: boolean;
    public TodayUTCDate: any;
    public showLoader = false;
    public moodId: any;

    constructor(private _httpService: HTTPService, private _sharedService: MySharedService) {
        AddMapScript();
        this.myDate = new Date();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        this.constant = new Constants();
    }

    ngOnInit() {
         this.getAttendance();
    }

    public getAttendance() {
        this.showLoader = true;
        this.showDetail = false;
        this.showOutTimelbl = false;
        this.showOutBtn = false;        
        this.attendanceDetail.AttendanceId = 0; this.attendanceDetail.InIP = null; this.attendanceDetail.InLatitude = null; this.attendanceDetail.InLongitude = null;       
        this._httpService.ajaxPost("Attendance/GetUserAttendance", { "UserId": this.userDetail.SiteUserId }).subscribe(
            data => {
                this.TodayUTCDate=moment(data["UTCTime"]);
                if (data["Attendance"] != null && data["Attendance"].length > 0) {
                    this.attendanceDetail = data["Attendance"][0];
                    this.attendanceDetail.showInDateTime = (this.attendanceDetail.InDateTime != null ? (this.attendanceDetail.InDateTime + ":00") : null);
                    this.attendanceDetail.showOutDateTime = this.attendanceDetail.OutDateTime + ":00";
                    this.showOutTimelbl = this.attendanceDetail.OutDateTime != null ? true : false;
                }
                else {
                    this.utcTime = moment(data["UTCTime"]);                    
                    this.attendanceDetail.Date = moment(this.utcTime).format('DD/MM/YYYY');
                    this.attendanceDetail.showInDateTime = moment(this.utcTime).format('DD/MM/YYYY HH:mm:ss');
                    this.attendanceDetail.showOutDateTime = moment(this.utcTime).format('DD/MM/YYYY HH:mm:ss');
                }
            },
            err => {             
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constant.globalError);
            },
            () => {
                this.showLoader = false;
                this.geolocateUser();
                // when InTime done
                if (this.attendanceDetail.AttendanceId != 0) {
                    this.showDetail = true;
                    if (this.attendanceDetail.OutDateTime == null) {
                        this.showOutBtn = true;
                    }
                }
                // when inTime is remaining
                else {                   
                    this.attendanceDetail.AttendanceId = 0; this.attendanceDetail.InIP = null; this.attendanceDetail.InLatitude = null; this.attendanceDetail.InLongitude = null;
                    this.attendanceDetail.Date = moment(this.TodayUTCDate).format('DD/MM/YYYY');
                    this.timer = setInterval(() => {
                        this.utcTime = moment(this.utcTime).add(1, 'seconds');
                        this.attendanceDetail.showInDateTime = moment(this.utcTime).format('DD/MM/YYYY HH:mm:ss');
                        this.attendanceDetail.showOutDateTime = moment(this.utcTime).format('DD/MM/YYYY HH:mm:ss');
                    }, 1000);
                    this.showDetail = false;
                    this.showOutBtn = false;
                }
            }
        );
    }

public SaveSmily()
{
  this.moodId=1; 
  this.SavePresent(); 
}
public SaveSad()
{
  this.moodId=2; 
  this.SavePresent(); 
}
public SaveNormal()
{
  this.moodId=3; 
  this.SavePresent(); 
}
public SaveNone()
{
  this.moodId=0; 
  this.SavePresent(); 
}


    public SavePresent() {
        clearInterval(this.timer);
        this.attendanceDetail.UserId = this.userDetail.SiteUserId;
        this.attendanceDetail.InIP = this.geoLocationModel.IP;
        this.attendanceDetail.InLatitude = this.geoLocationModel.Latitude;
        this.attendanceDetail.InLongitude = this.geoLocationModel.Longitude;
        this.attendanceDetail.InAddress = this.geoLocationModel.Address;
        this.attendanceDetail.MarkedBy = this.userDetail.SiteUserId;
        this.attendanceDetail.ApprovedBy = null;
        this.attendanceDetail.InDateTime = null;
        this.attendanceDetail.MoodId =this.moodId;
        if (this.attendanceDetail.IsTodayHoliday == true) {
            this.attendanceDetail.StatusId = this.constant.enumAttendanceStatus["NotApproved"];
        }
        else {
            this.attendanceDetail.StatusId = this.constant.enumAttendanceStatus["Present"];
        }
        this.attendanceDetail.IsPresent = true;
        this.showLoader = true;
        this._httpService.ajaxPost("Attendance/AddUpdateAttendance", this.attendanceDetail).subscribe(
            data => {
                this._sharedService.ShowMessage(data["Status"].Message);
            },
            err => {             
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constant.globalError);
            },
            () => {
                this.showLoader = false;
                this.getAttendance();                          
            }
        );
    }

    public MarkPresentOUT(dt: any) {
        var flag = true;
        var errorMessage = '';
        this.attendanceModel = JSON.parse(JSON.stringify(dt));
        this.attendanceModel.OutDateTime = null;
        this.attendanceModel.MarkedBy = this.userDetail.SiteUserId;
        this.attendanceModel.ApprovedBy = null;
        if (this.attendanceModel.MarkedBy != null) {
            if (this.attendanceModel.AttendanceId != 0) {
                this.attendanceModel.OutIP = this.geoLocationModel.IP;
                this.attendanceModel.OutLatitude = this.geoLocationModel.Latitude;
                this.attendanceModel.OutLongitude = this.geoLocationModel.Longitude;
                this.attendanceModel.OutAddress = this.geoLocationModel.Address;
            }
            else {
                this.attendanceModel.InIP = this.geoLocationModel.IP;
                this.attendanceModel.InLatitude = this.geoLocationModel.Latitude;
                this.attendanceModel.InLongitude = this.geoLocationModel.Longitude;
                this.attendanceModel.InAddress = this.geoLocationModel.Address;
            }
        }

        if (flag) {
            this.showLoader = true;
            this._httpService.ajaxPost("Attendance/AddUpdateAttendance", this.attendanceModel).subscribe(
                data => {
                    this._sharedService.ShowMessage(data["Status"].Message);
                },
                err => {                  
                    this.showOutTimelbl = false;
                    this.showLoader = false;
                    this._sharedService.ShowMessage(this.constant.globalError);
                },
                () => {
                    this.showLoader = false;
                    this.getAttendance();
                    this.showDetail = true;
                    this.showOutBtn = false;
                    this.showOutTimelbl = true;
                }
            );
        }
        else { this._sharedService.ShowMessage(errorMessage); }
    }




    public getformattedAddress(results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
            this.geoLocationModel.Address = results[0].formatted_address;
        }
        else {
            this.geoLocationModel.Address = "Unable to retrieve your address";
        }
    }
    public geolocationSuccess(position) {      
        var userLatLng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({
            "location": userLatLng
        }, this.getformattedAddress.bind(this));

        this.geoLocationModel.Latitude = position.coords.latitude;
        this.geoLocationModel.Longitude = position.coords.longitude;
        this.showLoader = false;
    }

    public geolocationError(positionError) {
        this.geoError = positionError.message;
        this.attendanceDetail.InIP = null; this.attendanceDetail.InLatitude = null; this.attendanceDetail.InLongitude = null;
        this.showLoader = false;
    }

    public geolocateUser() {
        this.showLoader = true;
        this._httpService.ajaxGetIP().subscribe(
            data => {
                this.geoLocationModel.IP = data["ip"];
            },
            err => {
                this.geoLocationModel.IP = "Not Found.";
                this.showLoader = false;
                this.callGeoLocation();
            },
            () => {
                this.showLoader = false;
                this.callGeoLocation();
            }
        );
    }

    callGeoLocation() {
        if (navigator.geolocation) {
            var positionOptions = {
                enableHighAccuracy: true,
                timeout: 5000 // 3 seconds
            };
            this.showLoader = true;
            navigator.geolocation.getCurrentPosition(this.geolocationSuccess.bind(this), this.geolocationError.bind(this), positionOptions);
        }
        else {
            this.geoError = "Your browser doesn't support the Geolocation API";
            this.attendanceDetail.AttendanceId = 0; this.attendanceDetail.InIP = null; this.attendanceDetail.InLatitude = null; this.attendanceDetail.InLongitude = null;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./TypeScripts/Attendance/attendance.component.ts
 **/